<template>
  <div class="column is-12" id="chartsBottom">
    <h2 v-if="text.title" class="subtitle has-text-centered">
      <span v-html="text.title"></span>
      <small v-if="text.title_info" v-tooltip class="has-tooltip-right has-tooltip-multiline tooltip-has-enters"
        :data-tooltip="text.title_info.replace(/;/g, '\u000D\u000A')">
        <font-awesome-icon :size="'xs'" :icon="icons.info" />
      </small>
    </h2>
    <div class="columns">
      <loader :loading="!loaded" :fixed="false"></loader>
      <div class="field column is-8 is-offset-2">
        <div class="tabs is-small is-toggle is-centered">
          <ul>
            <li :class="{ 'is-active': item.key === activeFilter[0] }" v-for="(item, i) in selection" :key="i">
              <a @click="ChangeActive(item.key)">
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>
        <chart class="chart" v-if="loaded" :options="chartsData" :constructor-type="'chart'" :updateArgs="[
          true,
          true,
          {
            duration: 1000,
          },
        ]"></chart>
      </div>
    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsHeatmap from 'highcharts/modules/heatmap.js'
import { Chart } from 'highcharts-vue'
import loader from '@/components/Loader.vue'
import moment from 'moment'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

HighchartsMore(Highcharts)
HighchartsHeatmap(Highcharts)

export default {
  name: 'contentChartsBottom',
  props: {
    text: {
      type: Object,
      required: false,
      default: () => { }
    },
    countryCode: {
      type: String,
      default: 'NLD'
    }
  },
  data () {
    return {
      loaded: false,
      chartsData: null,
      chartsOptions: null,
      activeFilter: [0],
      country: this.countryCode || this.$store.state.country,
      icons: {
        info: faInfoCircle
      }
    }
  },
  components: { Chart, loader },
  computed: {
    activeColorIndex () {
      return this.$store.state.dark ? 1 : 0
    },
    data () {
      return this.$store.state.publicAccidentData
    },
    selection () {
      return [
        { key: 0, name: this.text.total_accidents || 'TOTAL_ACCIDENTS' },
        { key: 1, name: this.text.victim_accidents || 'VICTIM_ACCIDENTS' }
      ]
    }
  },
  methods: {
    // getTitleInfo: function () {
    //   var _this = this
    //   for(var i = 0; i < _this.data.WeekdayTimeChart.LabelsY.length; i++){

    //   }
    //   return _this.data.WeekdayTimeChart.LabelsY.split(',').map(function (i) {//'test\u000D\u000Atest'
    //       return _this.$t('Charts.' + i.replace(/"/g, ''))
    //     })
    // },
    ChangeActive: function (idx) {
      this.activeFilter = [idx]
      this.setChartData()
    },
    setChartData: function () {
      var _this = this
      _this.loaded = false
      var labels = {
        x: _this.data.WeekdayTimeChart.Labels.split(',').map(function (i) {
          return moment()
            .locale(_this.$store.state.language)
            .weekday(i.replace(/"/g, '').replace('DAY_', '') - 1)
            .format('dddd')
        }),
        y: _this.data.WeekdayTimeChart.LabelsY.split(',').map(function (i) {
          return _this.$t('Charts.' + i.replace(/"/g, ''))
        })
      }

      var title = _this.data.WeekdayTimeChart.Data[_this.activeFilter[0]].Title
      if (
        _this.data.WeekdayTimeChart.Data[_this.activeFilter[0]].Title ===
        'TOTAL_ACCIDENTS' &&
        _this.text.total_accidents
      ) {
        title = _this.text.total_accidents
      }
      if (
        _this.data.WeekdayTimeChart.Data[_this.activeFilter[0]].Title ===
        'VICTIM_ACCIDENTS' &&
        _this.text.victim_accidents
      ) {
        title = _this.text.victim_accidents
      }

      _this.chartsData = {
        chart: {
          reflow: true,
          type: 'heatmap',
          backgroundColor: 'transparent'
        },
        title: null,
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        xAxis: {
          min: 0,
          max: 6,
          startOnTick: true,
          endOnTick: true,
          tickWidth: 1,
          lineWidth: 1,
          gridLineColor: 'transparent',

          categories: labels.x
        },
        yAxis: {
          categories: labels.y,
          gridLineColor: 'transparent',
          title: null,
          startOnTick: true,
          endOnTick: true,
          tickWidth: 1,
          lineWidth: 1,
          min: 0,
          max: 6,
          reversed: true
          // labels: {
          //   formatter: function () {
          //     // return this.value + '<br><small style="font-size:8px;">' + labels.y_long[6] + '</small>'
          //     return '<span class="has-tooltip-right has-tooltip-multiline" data-tooltip="' + labels.y_long[6] + '">' + this.value + '</span>'
          //   }
          // }
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            var tooltip = ''
            tooltip +=
              '<span style="background-color:' +
              this.point.color +
              ';width:5px;height:5px;border-radius:50%;display:inline-block;vertical-align:middle;"></span> <strong>' +
              this.series.name +
              '</strong>'
            tooltip +=
              '<br><span>' +
              labels.x[this.point.x] +
              ' ' +
              _this.$t('Charts.InThe') +
              ' ' +
              labels.y[this.point.y].toLowerCase() +
              ': </span>'
            tooltip +=
              '<strong>' +
              Highcharts.numberFormat(this.point.value, 0) +
              '</strong>'
            return tooltip
          }
        },
        colorAxis: {
          startOnTick: true,
          endOnTick: true,
          min: 0
          // minColor: "#FFFFFF",
          // maxColor: "rgb(226,97,99)",
        },
        plotOptions: {
          nullColor: '#FFFFFF'
        },
        series: [
          {
            name: title, // this.data.WeekdayTimeChart.Data[this.activeFilter[0]].Title,
            data: _this.data.WeekdayTimeChart.Data[this.activeFilter[0]].Data,
            borderWidth: 2,
            borderColor: '#ffffff',
            dataLabels: {
              enabled: true,
              style: {
                fontWeight: 'normal',
                textOutline: 0
              },
              color: '#333333'
              // formatter: function () {
              //   return this.point.value
              // }
            }
          }
        ]
      }
      _this.loaded = true
    }
  },
  mounted () {
    var _this = this

    _this.country = _this.countryCode || _this.$store.state.country

    if (this.$store.state.publicAccidentData) {
      this.setChartData()
    } else {
      this.$store.dispatch('getPublicAccidentData', _this.country)
    }
  },
  watch: {
    '$store.state.publicAccidentData': {
      handler: function () {
        if (this.$store.state.publicAccidentData) {
          this.setChartData()
        }
      },
      immediate: false
    },
    '$store.state.language': {
      handler: function () {
        if (this.$store.state.publicAccidentData) {
          this.setChartData()
        }
      },
      immediate: false
    },
    '$store.state.dark': {
      handler: function () {
        if (this.$store.state.publicAccidentData) {
          this.setChartData()
        }
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
#chartsBottom {
  height: 315px;

  .columns {
    position: relative;

    .is-8 {
      height: 260px;
    }

    .chart {
      height: 260px;
    }
  }

  /deep/strong {
    color: #333333;
  }

  @media screen and (max-width: $bp-tablet - 1px) {
    height: auto;

    .columns {
      .chart {
        height: 200px;
      }
    }
  }
}
</style>
